// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3oa_N","requiredAsterisk":"Info_requiredAsterisk__V2ygA"};